// brands.js — Gas Station Co. Brands Page

document.addEventListener('DOMContentLoaded', function () {

  var tabs  = document.querySelectorAll('.brands-tab');
  var cards = document.querySelectorAll('.brand-card');
  var empty = document.getElementById('brandsEmpty');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {

      // Aktiven Tab setzen
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');

      var filter = tab.getAttribute('data-filter');
      var visible = 0;

      cards.forEach(function (card) {
        var cats = card.getAttribute('data-cat') || '';
        var show = filter === 'alle' || cats.indexOf(filter) !== -1;
        if (show) {
          card.classList.remove('is-hidden');
          visible++;
        } else {
          card.classList.add('is-hidden');
        }
      });

      // Empty State
      if (empty) {
        empty.style.display = visible === 0 ? 'block' : 'none';
      }
    });
  });

});
